import {Injectable} from '@angular/core';
import {HttpHeaders, HttpClient, HttpParams} from '@angular/common/http';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import {Observable} from 'rxjs/Observable';
import {JwtService} from './jwt.service';
import {ErrorObservable} from 'rxjs/observable/ErrorObservable';
import {catchError} from 'rxjs/operators/catchError';
import {ApiConfig} from '../utils/config';
import { map } from 'rxjs/operators';
import {Router} from '@angular/router';

export interface ApiResponse {
    success: boolean;
    result: any;
}

@Injectable()
export class ApiService {
    private serviceAlive = new Subject();

    constructor(
        private http: HttpClient,
        private jwtService: JwtService,
        private apiConfig: ApiConfig,
        private router: Router,
    ) {}

    private formatErrors(error: any, jwt, router) {
      if(error.status === 401) {
        jwt.destroyToken();
        router.navigate(['/login']);
        document.location.reload(true);
      }
      return new ErrorObservable(error.error);
    }

    get(path: string, params: HttpParams = new HttpParams()): Observable<ApiResponse> {
        return this.http.get(`${this.apiConfig.API_URL}${path}`, {params})
          .pipe(catchError(err => this.formatErrors(err, this.jwtService, this.router)));
    }

    getProductConfigolicies(path: string, params: HttpParams = new HttpParams()): any {
        return this.http.get('https://truckbuilder-9000.conf.prod.rapidimages.net/assets/product-config-policies.json')
            .pipe(
                takeUntil(this.serviceAlive),
                filter(productId => productId !== undefined)
            )
    }

    put(path: string, body: Object = {}): Observable<ApiResponse> {
        return this.http.put(
            `${this.apiConfig.API_URL}${path}`,
            JSON.stringify(body)
        ).pipe(catchError(err => this.formatErrors(err, this.jwtService, this.router)));
    }

    post(path: string, body: Object = {}, headers = {}): Observable<ApiResponse> {
        return this.http.post(
            `${this.apiConfig.API_URL}${path}`,
            JSON.stringify(body),
            {
                headers: {
                    ...headers,
                    'Content-Type': 'application/json'
                }
            }
        ).pipe(catchError(err => this.formatErrors(err, this.jwtService, this.router)));
    }

    uploadFile(body, pathToFolder, filename, apiPath) {
        return Observable.create(observer => {
            const xhr = new XMLHttpRequest();
            const token = this.jwtService.getToken();

            xhr.onreadystatechange = () => {

                if (xhr.readyState === XMLHttpRequest.OPENED) {
                    xhr.setRequestHeader('Authorization', `Bearer ${token}`);
                    xhr.setRequestHeader('pathToFolder', pathToFolder);
                    xhr.setRequestHeader('filename', filename);
                    xhr.send(body);
                }
                if (xhr.readyState !== XMLHttpRequest.DONE) {
                    // console.log(xhr);
                    return {};
                }
                if (xhr.status === 200) {
                    const json = JSON.parse(xhr.responseText);
                    if (json.success) {
                        observer.next(json);
                        observer.complete();
                    }
                } else {
                    console.warn('error');
                    observer.error(xhr.response);
                }
            };
            xhr.open('POST', `${this.apiConfig.API_URL}${apiPath}`);
        });
    }

    delete(path: string, params?: any, options?: {}): Observable<ApiResponse> {
        return this.http.delete(
            `${this.apiConfig.API_URL}${path}`,
            params
        ).pipe(catchError(err => this.formatErrors(err, this.jwtService, this.router)));
    }
}



// WEBPACK FOOTER //
// ./src/app/common/services/api.service.ts